export default {
  'name': {
    'key': 'name',
    'name': '姓名',
    'required': true,
    'regName': 'checkIsEmpty'
  },
  'gender': {
    'key': 'gender',
    'name': '性别',
    'type': 'radio',
    'required': true,
    'labels': [
      { 'id': 'g1', 'value': 'M', 'name': '先生', 'checked': true },
      { 'id': 'g2', 'value': 'F', 'name': '女士' }
    ],
    'regName': 'checkIsEmpty'
  },
  'birthday': {
    'key': 'birthday',
    'name': '生日',
    'type': 'DatePicker',
    'regName': 'checkIsEmpty'
  },
  'email': {
    'key': 'email',
    'name': 'E-mail',
    'required': true,
    'type': 'default',
    'regName': 'checkMail'
  },
  'wechat': {
    'key': 'wechat',
    'name': '微信号',
    'required': true,
    'type': 'default',
    'regName': 'checkIsEmpty'
  },
  'focus_areas_tags': {
    'key': 'focus_areas_tags',
    'name': '个人专注领域',
    'type': 'AutoComplete',
    'regName': 'checkIsEmpty',
    'required': true
  }, // 个人专注领域
  'expect_to_join': {
    'key': 'expect_to_join',
    'name': '期待加入的城市',
    'type': 'AutoComplete',
    'regName': 'checkIsEmpty',
    'required': true
  },
  // 穿衣尺码
  'size': {
    'key': 'size',
    'name': '穿衣尺码',
    'type': 'radio',
    'labels': [
      { 'id': 's1', 'value': '1', 'name': 'S 155-160' },
      { 'id': 's2', 'value': '2', 'name': 'M 160-165' },
      { 'id': 's3', 'value': '3', 'name': 'L 165-170' },
      { 'id': 's4', 'value': '4', 'name': 'XL 170-175' },
      { 'id': 's5', 'value': '5', 'name': 'XXL 175-180' },
      { 'id': 's6', 'value': '6', 'name': 'XXXL 180-185' },
      { 'id': 's7', 'value': '7', 'name': 'XXXXL 185-190 ' }
    ],
    'regName': 'checkIsEmpty'
  }
}
